import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class ArticleTag extends BaseModel {
  static override constructorName = 'ArticleTag'

  id: number = 0
  name: string = ''
  slug: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(ArticleTag)
